import { View } from '@gin-betting/core';

import { LIVE_SPORTEVENT_STATUSES } from 'app-constants';
import { ParentPath } from 'types';
import { useMemoSelector } from 'hooks';
import { makePropsSelector } from '../../selectors';
import {
    matchPropsToPick,
    marketPropsToPick,
    oddsPropsToPick,
    tournamentPropsToPick,
} from '../../constants';

interface Input {
    matchId: string | null;
}

interface Output {
    match: Pick<View.Match, typeof matchPropsToPick[number]> | null;
    market: Pick<View.Market, typeof marketPropsToPick[number]> | null;
    odds: Array<Pick<View.Odd, typeof oddsPropsToPick[number]>>;
    tournament: Pick<
        View.Tournament,
        typeof tournamentPropsToPick[number]
    > | null;
    competitors: View.CompetitorsValid;
    route: ParentPath;
    isLive: boolean;
}

const useColorfulBanner = ({ matchId }: Input): Output => {
    const {
        competitors,
        market,
        route,
        tournament,
        match,
        odds,
    } = useMemoSelector(makePropsSelector(), { matchId });
    const isLive = !!match && LIVE_SPORTEVENT_STATUSES.includes(match.status);

    return {
        isLive,
        competitors,
        match,
        market,
        route,
        odds,
        tournament,
    };
};

export default useColorfulBanner;
